import { useMutation } from "react-query";
import http from "infra/http";

function useIniciarCobranca() {
  return useMutation(
    `v1/cobranca/iniciar`,
    (unidadeId: string) =>
       http.post(`v1/cobranca/${unidadeId}/iniciar`),
  );
}

export default useIniciarCobranca;
